import { IPublicClientApplication } from '@azure/msal-browser'
import { protectedResources } from '../authConfig'
import { authorizedGet } from '../utils/authUtils'

export interface QrScanSummary {
  total: number
  last7Days: number
  last30Days: number
}

export interface QrScanDayPoint {
  date: string
  count: number
}

export interface QrScanLocationPoint {
  deviceAdvertisementId: number
  locationId: number | null
  locationName: string | null
  deviceName: string | null
  count: number
}

export interface QrScanDetailed {
  total: number
  series: QrScanDayPoint[]
  byLocation: QrScanLocationPoint[]
}

export const getScansSummary = async (
  advertisementId: number,
  instance: IPublicClientApplication,
): Promise<QrScanSummary> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedGet(
    instance,
    `${baseUrl}/advertisements/${advertisementId}/scans/summary`,
    protectedResources.scopes.read,
  )
}

export const getScansDetailed = async (
  advertisementId: number,
  instance: IPublicClientApplication,
  options?: {
    from?: string
    to?: string
    deviceAdvertisementId?: number
  },
): Promise<QrScanDetailed> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  const params = new URLSearchParams()
  if (options?.from) params.append('from', options.from)
  if (options?.to) params.append('to', options.to)
  if (options?.deviceAdvertisementId) {
    params.append(
      'deviceAdvertisementId',
      options.deviceAdvertisementId.toString(),
    )
  }
  const query = params.toString() ? `?${params.toString()}` : ''
  return await authorizedGet(
    instance,
    `${baseUrl}/advertisements/${advertisementId}/scans${query}`,
    protectedResources.scopes.read,
  )
}
